import { useState, useEffect } from "react"
import { Table } from 'react-bootstrap'
import api from "../components/api"

const Modal = (props) => {


    const [razao_social, setRazaoSocial] = useState()
    const [nome_fantasia, setNomeFantasia] = useState()
    const [adesao_institucional_id_ref, setAdesao_institucional_id_ref] = useState()
    const [email, setEmail] = useState()
    const [cnes, setCnes] = useState()
    const [numero, setNumero] = useState()
    const [endereco, setEndereco] = useState()
    const [cep, setCep] = useState()
    const [bairro, setBairro] = useState()
    const [municipio, setMunicipio] = useState()
    
    const [uf, setUf] = useState()
    const [cnpj, setCNPJ] = useState()
    const [nome_pessoa_preenche, setNomePessoaPreenche] = useState()
    const [cargo_pessoa_preenche, setCargoPessoaPreenche] = useState()
    const [telefone_pessoa_preenche, setTelefonePessoaPreenche] = useState()


    //const [categoriaAdesao, setCategoriaAdesao] = useState()
    const [tipoAlteracao, setTipoAlteracao] = useState()

    const [organizacaoGestora, setOrganizacaoGestora] = useState('')
    
    const [especOrganizacao, setEspecOrganizacao] = useState('')
    //const [porteOrganizacao, setPorteOrganizacao] = useState('')
    const [organizacao, setOrganizacao] = useState('')
    const [ambitoOrganizacao, setAmbitoOrganizacao] = useState('')

    const [cpf, setCPF] = useState('')
    const [telefoneCelular, setTelefoneCelular] = useState('')    
    const [complexidade, setComplexidade] = useState('')
    const [contratoGestao, setContratoGestao] = useState('')
    const [nomeOutraOrganizacaoGestora, setNomeOutraOrganizacaoGestora] = useState('')
    const [emailRepresentante, setEmailRepresentante] = useState('')
    const [site, setSite] = useState('')
    const [vinculacaoSUS, setVinculacaoSUS] = useState('')
    const [hospitalEspecializado, setHospitalEspecializado] = useState()
    const [especializacao, setEspecializacao] = useState('')
    const [especializadoOutros_descri, setEspecializadoOutros_descri] = useState('')

    const [listaServicosSaude, setListaServicosSaude] = useState()    
    const [listaNatureza, setListaNatureza] = useState()
    const [listaOrganizacao, setListaOrganizacao] = useState()

    const [organizacao_ambito_id, setOrganizacaoAmbitoId] = useState()
    const [organizacao_espec_id, setOrganizacaoEspecId] = useState()
    const [organizacao_id, setOrganizacaoId] = useState()
    const [porte_organizacao, setPorteOrganizacao] = useState('')
    const [categoria_adesao, setCategoriaAdesao] = useState()



    /*

    async function adesaoInstitucionalListaServicoSaude() {

        await api.get('adesaoInstitucionalListaServicoSaude').then((response) => {
            //console.log(response.data)

            setListaServicosSaude(response.data.map((rs) =>
                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>
                    {rs.razao_social}
                </option>
            ))

        }).catch((err) => {
            console.log(err.response)
        })

    }




    async function adesaoInstitucionalListaOrganizacao() {

        //console.log(categoria_adesao)

        if (categoria_adesao) {

            await api.get(`adesaoInstitucionalListaOrganizacao/${categoria_adesao}`).then((response) => {
                //console.log(response.data)
                setListaOrganizacao(response.data.map((rs) => 
                    <option value={rs.organizacao_espec_id}>
                        {rs.descricao}
                    </option>
                ))
            }).catch((err) => {
                console.log(err.response)
            })

        }

        

    }


    async function adesaoInstitucionalListaNatureza() {

        await api.get('adesaoInstitucionalListaNatureza').then((response) => {
            //console.log(response.data)
            setListaNatureza(response.data.map((rs) => 

                <option value={rs.organizacao_id} key={rs.organizacao_id}>
                    {rs.descricao}
                </option>
            
            ))
        }).catch((err) => {
            console.log(err.response)
        })

    }


    
    useEffect(() => {

        adesaoInstitucionalListaNatureza()
        adesaoInstitucionalListaOrganizacao()
        adesaoInstitucionalListaServicoSaude()

    }, [])
    */


    const carrega = () => {

        api.get(`adesaoInstitucionalAlteraDet/${props.alteraAdesaoInstitucional_id}`).then((result) => {

            //console.log(result.data)
            var data = result.data[0]

            setTipoAlteracao(data.tipoAlteracao)
            setCNPJ(data.cnpjAnterior)
            setRazaoSocial(data.razaoSocialAnterior)
            setNomeFantasia(data.nomeFantasiaAnterior)
            setCnes(data.cnesAnterior)
            setCep(data.cepAnterior)
            setEndereco(data.enderecoAnterior)
            setNumero(data.numeroAnterior)
            setBairro(data.bairroAnterior)
            setMunicipio(data.municipioAnterior)
            setUf(data.ufAnterior)
            setEmail(data.emailAnterior)
            setTelefonePessoaPreenche(data.telefoneAnterior)
            setNomePessoaPreenche(data.nomePessoaPreencheuAnterior)
            setCargoPessoaPreenche(data.cargoPessoaPreencheuAnterior)
            setCategoriaAdesao(data.categoriaAdesaoAnterior)
            setOrganizacaoGestora(data.organizacaoGestoraAnterior)
            setOrganizacao(data.organizacaoAnterior)
            setAmbitoOrganizacao(data.ambitoOrganizacaoAnterior)
            setPorteOrganizacao(data.porteOrganizacaoAnterior)
            setEspecOrganizacao(data.especOrganizacaoAnterior)

            //setOrganizacaoAmbitoId(data.organizacao_ambito_idAnterior)
            //setOrganizacaoEspecId(data.organizacao_espec_idAnterior)
            //setOrganizacaoId(data.organizacao_idAnterior)


            setTelefoneCelular(data.telefoneCelularAnterior)
            setComplexidade(data.complexidadeAnterior)
            setContratoGestao(data.contratoGestaoAnterior)
            setNomeOutraOrganizacaoGestora(data.nomeOutraOrganizacaoGestoraAnterior)
            setEmailRepresentante(data.emailRepresentanteAnterior)
            setSite(data.siteAnterior)
            setVinculacaoSUS(data.vinculacaoSUSAnterior)
            setHospitalEspecializado(data.hospitalEspecializadoAnterior == true ? '1' : data.hospitalEspecializadoAnterior == false ? '0' : null)
            setEspecializacao(data.especializacaoAnterior)
            setEspecializadoOutros_descri(data.especializadoOutros_descriAnterior)
            setCPF(data.cpfAnterior)

            //setAdesao_institucional_id_ref(data.adesao_institucional_id_refAnterior)

        }).catch((err) => {

            console.log(err.response)

        })

    }

    useEffect(() => {

        if (props.alteraAdesaoInstitucional_id) {

            carrega()

        }

    }, [props.alteraAdesaoInstitucional_id])

    return (

        <div>


            <div className="modal fade" id="ModalAlteracao" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">Alteração</h1>
                        </div>
                        <div class="modal-body">
                                
                                <div className="panel-body">
                                    
                                    

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Alteração</label>
                                            <input className="form-control" input="text" disabled value={tipoAlteracao} style={{ backgroundColor: '#cbd7f2'}} />
                                            
                                        </div>
                                    </div>




                                    <div className="col-12 mb-3">
                                        <h4 className="bg-light border-start border-4 border-primary p-2">
                                            <font color="brown">Dados cadastrais da organização</font>
                                        </h4>
                                    </div>


                                    

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>CNPJ</label>
                                            <input type="text" className="form-control" placeholder="" value={cnpj} disabled />
                                                            
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label>Razão Social</label>
                                            <input type="text" className="form-control" placeholder="" value={razao_social} disabled />
                                                            
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label>Nome Fantasia</label>
                                            <input type="text" className="form-control" placeholder="" value={nome_fantasia} disabled/>
                                            
                                        </div>
                                    </div>

                                    
                                    

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>CNES</label>
                                            <input type="text" className="form-control" placeholder="" value={cnes} disabled />
                                            
                                        </div>
                                    </div>
                                    


                                    <div className="col-md-3">
                                        <div class="form-group">
                                            <label for="exampleInputEmail1">CEP</label>
                                            <input type="email" className="form-control" placeholder="" value={cep} disabled/>
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label>Endereço</label>
                                            <input type="text" className="form-control" placeholder="" value={endereco}  disabled/>
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Número/Complemento</label>
                                            <input type="text" className="form-control" placeholder="" value={numero} disabled />
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Bairro</label>
                                            <input type="text" className="form-control" placeholder="" value={bairro}  disabled/>
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Município</label>
                                            <input type="text" className="form-control" placeholder="" value={municipio} disabled/>
                                            
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>UF</label>
                                            <input type="text" className="form-control" placeholder="" value={uf} disabled/>
                                            
                                        </div>
                                    </div>


                                    <div className="col-md-8">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Email institucional</label>
                                            <input type="email" className="form-control" placeholder="" value={email} disabled/>
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Endereço ou website da organização</label>                                            
                                            <input type="text" className="form-control" placeholder="" value={site} disabled/>
                                                            
                                        </div>
                                    </div>





                                    <div class="col-md-12">
                                        <h4 className="bg-light border-start border-4 border-primary p-2">
                                            <span style={{ color: "brown" }}>
                                                Dados do representante da organização perante o PHS
                                            </span>
                                        </h4>
                                    </div>


                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">CPF</label>                                                                                        
                                            <input type="text" className="form-control" placeholder="" value={cpf} disabled/>
                                        </div>
                                    </div>




                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <label >Nome</label>
                                            <input type="text" className="form-control" placeholder="" value={nome_pessoa_preenche} disabled/>
                                            
                                        </div>
                                    </div>



                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Telefone celular</label>
                                            <input type="text" className="form-control" placeholder="" value={telefoneCelular} disabled/>
                                            
                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Cargo</label>
                                            <input type="text" className="form-control" placeholder="" value={cargo_pessoa_preenche} disabled />
                                            
                                        </div>
                                    </div>



                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Email institucional do representante</label>
                                            <input type="text" className="form-control" placeholder="" value={emailRepresentante} disabled />                                            
                                                            
                                        </div>
                                    </div>



                                    

                                      <div class="col-md-12">
                                        <h4 className="bg-light border-start border-4 border-primary p-2">
                                            <span style={{ color: "brown" }}>
                                                Caracterização da Instituição
                                            </span>
                                        </h4>
                                    </div>


                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label" >Categoria de adesão: *</label>
                                            <select value={categoria_adesao} disabled className="form-control">
                                                <option value=""></option>
                                                <option value="S" >Serviços de assistência à saúde</option>
                                                <option value="G" >Organizações gestoras de redes de assistência à saúde</option>
                                                <option value="A" >Organizações acadêmicas, profissionais ou representativas da sociedade civil em geral</option>
                                            </select>
                                        </div>
                                    </div>

                                    {
                                        /*

                                        <div className="col-md-12" style={{ display: categoria_adesao == 'S' ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <label className="control-label" >Sua unidade pertence ou é gerenciada por alguma das redes de serviços de saúde, organizações sociais de saúde ou sistemas de saúde listados abaixo?</label>
                                                <select disabled class="form-control" onChange={event => {setAdesao_institucional_id_ref(event.target.value);setOrganizacaoGestora(event.target.options[event.target.selectedIndex].text)}} value={adesao_institucional_id_ref} >
                                                <option value="">[Selecione]</option>
                                                {listaServicosSaude}
                                                </select>
                                                    
                                            </div>
                                        </div>


                                        */
                                    }
                                    

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Tipo da organização</label>
                                            
                                            <input type="text" className="form-control" placeholder="" value={especOrganizacao} disabled />     
                                            
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Natureza da Organização</label>
                                            <input type="text" className="form-control" placeholder="" value={organizacao} disabled />     
                                            
                                            
                                        </div>
                                    </div>

                                    



                                    <div className="col-md-12">
                                        <div class="form-group" >
                                            <label className="control-label" >Sua unidade pertence ou é gerenciada por alguma das redes de serviços de saúde, organizações sociais de saúde ou sistemas de saúde listados abaixo?</label>
                                            <input type="text" className="form-control" placeholder="" value={organizacaoGestora} disabled />
                                                
                                        </div>
                                    </div>
                                    

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Âmbito da organização</label>
                                            <input type="text" className="form-control" placeholder="" value={ambitoOrganizacao} disabled />
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Sua unidade possui vinculação ao SUS?</label>
                                            <select
                                                className="form-control"
                                                value={vinculacaoSUS} 
                                                disabled
                                                >
                                                <option value="">[Selecione]</option>
                                                <option value="Sem atendimento SUS">Sem atendimento SUS</option>
                                                <option value="Abaixo de 60% dos atendimentos SUS">Abaixo de 60% dos atendimentos SUS</option>
                                                <option value="60% ou mais dos atendimentos SUS">60% ou mais dos atendimentos SUS</option>
                                                
                                                </select>
                                                            
                                        </div>
                                    </div>


                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Porte da organização - número de funcionários onários que trabalham na unidade, rede ou organização em questão, incluindo terceirizados e prestadores de serviços com carga horária semanal de 20 ou mais horas): *</label>
                                            <input disabled className="form-control" input="text" value={porte_organizacao} />
                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>A sua organização é proprietária da unidade ou opera por contrato de gestão?</label>
                                            <select
                                                className="form-control"
                                                //onChange={event => setContratoGestao(event.target.value)} 
                                                disabled
                                                value={contratoGestao} 
                                                >
                                                <option value="">[Selecione]</option>
                                                <option value="Somos proprietários e operadores principais da unidade">Somos proprietários e operadores principais da unidade</option>
                                                <option value="Operamos uma unidade municipal como OSS (Organização Social de Saúde)">Operamos uma unidade municipal como OSS (Organização Social de Saúde) </option>
                                                <option value="Operamos uma unidade estadual como OSS (Organização Social de Saúde)">Operamos uma unidade estadual como OSS (Organização Social de Saúde) </option>
                                                <option value="Operamos uma unidade federal como OSS (Organização Social de Saúde)">Operamos uma unidade federal como OSS (Organização Social de Saúde) </option>
                                                <option value="Operamos uma unidade municipal como PPP (Parceria Público-Privada)">Operamos uma unidade municipal como PPP (Parceria Público-Privada) </option>
                                                <option value="Operamos uma unidade estadual como PPP (Parceria Público-Privada)">Operamos uma unidade estadual como PPP (Parceria Público-Privada) </option>
                                                <option value="Operamos uma unidade federal como PPP (Parceria Público-Privada)">Operamos uma unidade federal como PPP (Parceria Público-Privada)</option>
                                                
                                                </select>
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Complexidade</label>

                                            <Table  bordered hover >
                                                <tbody>
                                                <tr>
                                                    <td colSpan={2}>
                                                    Tipo de unidade de saúde por complexidade dos serviços prestados*:
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ width: '100px' }}>
                                                    <input
                                                        type="radio"
                                                        value="B"
                                                        name='complexidade'
                                                        //onChange={event => setComplexidade(event.target.value)}
                                                        disabled
                                                        checked={ complexidade == 'B' }
                                                    />
                                                    </td>
                                                    <td>
                                                    
                                                    
                                                        Baixa complexidade
                                                        

                                                    
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                    <input
                                                        type="radio"
                                                        value="M"
                                                        name='complexidade'
                                                        //onChange={event => setComplexidade(event.target.value)}
                                                        disabled
                                                        checked={ complexidade == 'M'}
                                                    />
                                                    </td>
                                                    <td>
                                                        Média complexidade
                                                    
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                    <input
                                                        type="radio"
                                                        value="A"
                                                        name='complexidade'
                                                        //onChange={event => setComplexidade(event.target.value)}
                                                        disabled
                                                        checked={ complexidade == 'A'}
                                                    />
                                                    </td>
                                                    <td>
                                                        Alta complexidade
                                                    

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                    <input
                                                        type="radio"
                                                        value="T"
                                                        name='complexidade'
                                                        //onChange={event => setComplexidade(event.target.value)}
                                                        disabled
                                                        checked={ complexidade == 'T'}
                                                    />
                                                    </td>
                                                    <td>
                                                        Alta complexidade com transplante de órgão

                                                    
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </Table>
                                            
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-12">


                                        <Table  bordered hover>
                                            <tbody>
                                                
                                                <tr>
                                                <td  colSpan={2}>
                                                    Sua unidade de saúde é dedicada a uma especialidade?
                                                    

                                                </td>
                                                </tr>

                                                {/* SELECT */}
                                                <tr>
                                                <td colSpan={2}>
                                                    <select
                                                    className="form-control"
                                                    value={hospitalEspecializado}
                                                    //onChange={event => setHospitalEspecializado(event.target.value)}
                                                    disabled
                                                    >
                                                    <option value="">[Selecione]</option>
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                    </select>

                                                </td>
                                                </tr>

                                                {/* PERGUNTA EXTRA */}
                                                <tr style={{ display: hospitalEspecializado === '1' ? 'table-row' : 'none' }}>
                                                <td colSpan={2}>
                                                    Favor assinalar abaixo a opção aplicável:
                                                </td>
                                                </tr>

                                                {/* RADIO OPTIONS */}
                                                {[
                                                { value: 'C', label: 'Cardiologia' },
                                                { value: 'M', label: 'Maternidade/ Obstetrícia/ Ginecologia' },
                                                { value: 'N', label: 'Oncologia' },
                                                { value: 'P', label: 'Pediatria' },
                                                { value: 'S', label: 'Psiquiatria' },
                                                { value: 'O', label: 'Outros' }
                                                ].map((item) => (
                                                <tr
                                                    key={item.value}
                                                    style={{ display: hospitalEspecializado === '1' ? 'table-row' : 'none' }}
                                                >
                                                    <td style={{ width: '100px' }}>
                                                    <input
                                                        type="radio"
                                                        value={item.value}
                                                        checked={ item.value == especializacao }
                                                        //onChange={event => setEspecializacao(item.value)}
                                                        disabled
                                                    />
                                                    </td>
                                                    <td>{item.label}</td>
                                                </tr>
                                                ))}

                                                {/* TEXTAREA OUTROS */}
                                                <tr style={{ display: especializacao === 'O' ? 'table-row' : 'none' }}>
                                                <td colSpan={2}>
                                                    <textarea
                                                    className="form-control"
                                                    rows={5}
                                                    placeholder="Descreva..."
                                                    value={especializadoOutros_descri}
                                                    maxLength={4000}
                                                    //onChange={event => setEspecializadoOutros_descri(event.target.value)}
                                                    disabled
                                                    />

                                                </td>
                                                </tr>

                                            </tbody>
                                        </Table>



                                    </div>




                                    {

                                        /*


                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Organização</label>
                                                <input type="text" className="form-control" placeholder="" value={organizacao} disabled />
                                                
                                            </div>
                                        </div>
                                        

                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Tipo da organização</label>
                                                <input type="text" className="form-control" placeholder="" value={especOrganizacao} disabled />
                                                
                                            </div>
                                        </div>

                                    

                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Porte da organização - número de funcionários onários que trabalham na unidade, rede ou organização em questão, incluindo terceirizados e prestadores de serviços com carga horária semanal de 20 ou mais horas): *</label>
                                                <input type="text" className="form-control" placeholder="" value={porteOrganizacao} disabled />
                                                
                                            </div>
                                        </div>
                                        */
                                    }


                                    

                                </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            
                            
                            
                        </div>
                    </div>
                </div>
            </div>



        </div>

    )

}

export default Modal